module.exports = __webpack_public_path__ + "img/7.56757fae.png";